/**
 * Feature flags for gradual rollout of features
 */

// TODO - remove this once AT THE END OF THE YEAR 2025
const V2_SWITCH_SHOW_FOR_ALL_USERS = Object.freeze([
  'americandentalassociation'
  // 'gondor',
]);
export const shouldShowV2SwitchForAllUsers = (slug?: string) => {
  return V2_SWITCH_SHOW_FOR_ALL_USERS.includes(slug ?? '');
};
